import axios from "axios"
import { BaseUrl, JsonConfig } from "./BaseRepository";
import { ErrorMessage } from "../Utils/Utils";

export const selectMasterfileFrequency = async (props) => {
    let value = props;
    try {
        let url;
        if (value === "Weekly") {
            url = `${BaseUrl}Paychex/GettingdatafromMasterFile?Frequency=Weekly`
        }
        else {
            url = `${BaseUrl}Paychex/GettingdatafromMasterFile?Frequency=Bi-Weekly`
        }
        const res = await axios.get(url, JsonConfig);
        let loopList = []
        if (res.data.statusCode === 200) {
            let tempdata = res.data;
            const tempList = JSON.parse(tempdata.payload)
            let len = tempList.length;
            for (let i = 0; i < len; i++) {
                var newHiredt;
                if (tempList[i].hire_date !== null) {
                    if (tempList[i].hire_date !== undefined) {
                        const dateString = tempList[i].hire_date;
                        const [fullDate, time] = dateString.split('T');
                        const [year, month, date] = fullDate.split('-');
                        const [hour, minute, sec] = time.split(':');
                        const second = sec.replace("Z", "");
                        const dateTime = new Date(year, month - 1, date, hour, minute, second);
                        newHiredt = dateTime.toLocaleDateString("en-us");
                    }
                }
                var newTermdt;
                if (tempList[i].term_date !== null) {
                    if (tempList[i].term_date !== undefined) {
                        if (tempList[i].term_date !== "0001-01-01T00:00:00Z") {
                            const dateString_td = tempList[i].term_date;
                            const [fullDate_td, time_td] = dateString_td.split('T');
                            const [year_td, month_td, date_td] = fullDate_td.split('-');
                            const [hour_td, minute_td, sec_td] = time_td.split(':');
                            const second_td = sec_td.replace("Z", "");
                            const dateTime_td = new Date(year_td, month_td - 1, date_td, hour_td, minute_td, second_td);
                            newTermdt = dateTime_td.toLocaleDateString("en-us");
                        }
                    }
                }
                // var newWeekendDate = "";
                // if (tempList[i].WeekendDate !== null) {
                //     if (tempList[i].WeekendDate !== undefined) {
                //         const dateString_wd = tempList[i].WeekendDate;
                //         const [fullDate_wd, time_wd] = dateString_wd.split('T');
                //         const [year_wd, month_wd, date_wd] = fullDate_wd.split('-');
                //         const [hour_wd, minute_wd, sec_wd] = time_wd.split(':');
                //         const second_wd = sec_wd.replace("Z", "");
                //         const dateTime_wd = new Date(year_wd, month_wd - 1, date_wd, hour_wd, minute_wd, second_wd);
                //         newWeekendDate = dateTime_wd.toLocaleDateString("en-us");
                //     }
                // }
                var newPaydt;
                if (tempList[i].payDate !== null) {
                    if (tempList[i].payDate !== undefined) {
                        const dateString_pd = tempList[i].payDate;
                        const [fullDate_pd, time_pd] = dateString_pd.split('T');
                        const [year_pd, month_pd, date_pd] = fullDate_pd.split('-');
                        const [hour_pd, minute_pd, sec_pd] = time_pd.split(':');
                        const second_pd = sec_pd.replace("Z", "");
                        const dateTime_pd = new Date(year_pd, month_pd - 1, date_pd, hour_pd, minute_pd, second_pd);
                        newPaydt = dateTime_pd.toLocaleDateString("en-us");
                    }
                }
                loopList.push({
                    Id: tempList[i].Id,
                    comp_code: tempList[i].comp_code,
                    file_number: tempList[i].file_number,
                    pcx_emp_name: tempList[i].pcx_emp_name,
                    portal_emp_name: tempList[i].portal_emp_name,
                    state: tempList[i].state,
                    client: tempList[i].client,
                    hire_date: newHiredt,
                    // hire_date: tempList[i].hire_date,
                    rate_type: tempList[i].rate_type,
                    pay_rate: tempList[i].pay_rate,
                    pay_frequency: tempList[i].pay_frequency,
                    flsa: tempList[i].flsa,
                    term_date: newTermdt,
                    // term_date: tempList[i].term_date,
                    emp_status: tempList[i].emp_status,
                    period: tempList[i].period,
                    temp_rate: tempList[i].temp_rate,
                    rt_wk1: tempList[i].rt_wk1,
                    ot_wk1: tempList[i].ot_wk1,
                    dt_wk1: tempList[i].dt_wk1,
                    status_W: tempList[i].status_W,
                    rt_wk2: tempList[i].rt_wk2,
                    ot_wk2: tempList[i].ot_wk2,
                    dt_wk2: tempList[i].dt_wk2,
                    status_B: tempList[i].status_B,
                    rt_total: tempList[i].rt_total,
                    ot_total: tempList[i].ot_total,
                    dt_total: tempList[i].dt_total,
                    sal_amnt: tempList[i].sal_amnt,
                    holiday_hrs: tempList[i].holiday_hrs,
                    sick_hrs: tempList[i].sick_hrs,
                    pto_hrs: tempList[i].pto_hrs,
                    covid_hrs: tempList[i].covid_hrs,
                    training_hrs: tempList[i].training_hrs,
                    gym_amnt: tempList[i].gym_amnt,
                    fmla_amnt: tempList[i].fmla_amnt,
                    sevpay_amnt: tempList[i].sevpay_amnt,
                    bonus_amnt: tempList[i].bonus_amnt,
                    missingInPaychexList: tempList[i].missingInPaychexList,
                    insertDate: tempList[i].insertDate,
                    payDate: newPaydt,
                    // payDate: tempList[i].payDate,
                    ticket_Number: tempList[i].Ticket_Number,
                    chequesequence: tempList[i].chequesequence,
                    remarks: tempList[i].remarks,
                    ALOT: tempList[i].ALOT,
                    // WeekendDate: newWeekendDate,
                    WeekendDate: tempList[i].WeekendDate
                })
            }
            return loopList
        }
        else if (res.data.statusCode === 204) {
            InfoMessage(res.data.message);
            return loopList;
        }
        else {
            ErrorMessage(res.data.message);
            return loopList;
        }
    } catch (err) {
        ErrorMessage("Unable to get data");
        return null;
    }
};
export const updateMasterfile = async (props) => {
    try {
        let data = props;
        let url = `${BaseUrl}Paychex/updatingMasterFileData`
        const response = await axios.put(url, data, JsonConfig)
        return response
    }
    catch (err) {
        ErrorMessage("Cannot able to update");
        return null;
    }
}
export const callPaychexUploadTemplateApi = async (freq) => {
    try {
        let url = `${BaseUrl}Paychex/PaychexUploadTemplate?Frequency=${freq}`
        // let url = `https://localhost:44305/api/Paychex/PaychexUploadTemplate?Frequency=${freq}`
        const response = await axios.get(url, JsonConfig)
        return response;
    }
    catch {
        ErrorMessage("Cannot able to get data");
    }
}